var map = {
	"./articles.en.js": [
		218,
		43
	],
	"./articles.es.js": [
		219,
		42
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 169;


//////////////////
// WEBPACK FOOTER
// ./app/data/articles lazy ^\.\/articles\..*\.js$
// module id = 169
// module chunks = 59